import React from "react";
import classNames from "classnames";
import { compose } from "redux";
import { useLocation } from "react-router-dom";
import Formsy from "formsy-react";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import withTranslations from "../../../../../hocs/withTranslations";
import SquaberLink from "../../../common/SquaberLink";
import SocialLogin from "../../SocialLogin";
import AuthOrDivider from "../../AuthPageLayout/components/AuthOrDivider";
import { UrlProvider } from "../../../../../api/UrlProvider";
import { appendSearchToUrl } from "../../../../../lib/url/appendQueryStringToUrl";
import "../../authForm.scss";

function NewRegisterFormContent({
  formBuilder,
  registerLoading,
  validationErrors,
  clearValidationError,
  onSubmit,
  locale,
  showLoginLink = true,
  showSubmitButton = true,
  loginLinkTo,
  formRef,
  className,
  translate
}) {
  const { search } = useLocation();
  const loginTo = loginLinkTo
    ? loginLinkTo
    : appendSearchToUrl(UrlProvider.getUrl("fe.login", { locale }), search);

  return (
    <div className={classNames("new-register-form-content", className)}>
      <SocialLogin />
      <AuthOrDivider />
      <Formsy
        ref={formRef}
        onValidSubmit={onSubmit}
        validationErrors={validationErrors}
      >
        <FormBuilderWeb
          {...formBuilder}
          clearValidationError={clearValidationError}
          validationErrors={validationErrors}
        />
        {showSubmitButton ? (
          <button
            type={"submit"}
            disabled={registerLoading}
            className={
              "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
            }
          >
            {registerLoading ? (
              <i className="fal fa-spinner fa-spin text-black font-semibold mr-2" />
            ) : null}
            {translate("auth_register-page_submit")}
          </button>
        ) : null}
        {showLoginLink ? (
          <p
            className={"text-sm line-height-100 font-medium text-black-5 mb-8"}
          >
            {translate("auth_register-page_has-account")}{" "}
            <strong className={"font-bold text-black"}>
              <SquaberLink to={loginTo} className={"ml-2"}>
                {translate("auth_register-page_login-link")}
              </SquaberLink>
            </strong>
          </p>
        ) : null}
      </Formsy>
    </div>
  );
}

export default compose(withTranslations)(NewRegisterFormContent);
